var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrsScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00013 3.19543C2.00013 2.62695 2.44732 2.16657 2.99951 2.16657H5.49983C6.05202 2.16657 6.50015 1.70523 6.50015 1.13675C6.50015 0.568277 6.05202 0.106934 5.49983 0.106934H2.99951C1.34296 0.106934 -0.000488281 1.49 -0.000488281 3.19541V5.76946C-0.000488281 6.33794 0.44764 6.79928 0.999832 6.79928C1.55202 6.79928 2.00015 6.33794 2.00015 5.76946L2.00013 3.19543Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 0.106934C13.9476 0.106934 13.4995 0.568277 13.4995 1.13675C13.4995 1.70523 13.9476 2.16657 14.4998 2.16657H17.0002C17.5523 2.16657 17.9995 2.62695 17.9995 3.19543V5.76949C17.9995 6.33796 18.4477 6.79931 18.9999 6.79931C19.552 6.79931 20.0002 6.33796 20.0002 5.76949V3.19543C20.0002 1.49003 18.6567 0.106958 17.0002 0.106958L14.4998 0.106934Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00015 15.0349C2.00015 14.4665 1.55202 14.0051 0.999832 14.0051C0.44764 14.0051 -0.000488281 14.4665 -0.000488281 15.0349V17.609C-0.000488281 19.3144 1.34296 20.6975 2.99951 20.6975H5.49983C6.05202 20.6975 6.50015 20.2361 6.50015 19.6677C6.50015 19.0992 6.05202 18.6378 5.49983 18.6378H2.99951C2.44732 18.6378 2.00013 18.1775 2.00013 17.609L2.00015 15.0349Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.0349C20 14.4665 19.5519 14.0051 18.9997 14.0051C18.4475 14.0051 17.9994 14.4665 17.9994 15.0349V17.609C17.9994 18.1775 17.5522 18.6379 17 18.6379H14.9994C14.4472 18.6379 14 19.0992 14 19.6677C14 20.2362 14.4472 20.6975 14.9994 20.6975H17C18.6566 20.6975 20 19.3144 20 17.609L20 15.0349Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999832 9.37231C0.44764 9.37231 -0.000488281 9.83366 -0.000488281 10.4021C-0.000488281 10.9706 0.44764 11.432 0.999832 11.432H18.9998C19.552 11.432 20.0002 10.9706 20.0002 10.4021C20.0002 9.83366 19.552 9.37231 18.9998 9.37231H0.999832Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrsScanIcon);
export default __webpack_public_path__ + "static/media/drsScanIcon.fb7322f6289eb158347465fccf4bea74.svg";
export { ForwardRef as ReactComponent };